import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getFilterTextFieldValue } from '@features/filter/static/filterUtil';

import { updateTextItemInGlobalFilter } from '@store/actions/FilterAction';

const OrderCancelStatusFilter = () => {
	const filterData = useSelector((store) => store.filterFieldStore);
	const inputValue = getFilterTextFieldValue(filterData, 'status', 'status-order');
	const dispatch = useDispatch();

	const handleChange = (e) => {
		let { value } = e.target;
		let data = {
			name: 'status',
			type: 'text',
			key:
				value === 'Request Pending'
					? 'REQUESTED'
					: value === 'Request Completed'
						? 'APPROVED'
						: 'REJECTED',
			value: value,
			identifier: 'status-order'
		};
		dispatch(updateTextItemInGlobalFilter(data));
	};

	return (
		<div className="sort-button mr-2 pr-1">
			<select
				name="status"
				id
				onChange={handleChange}
				className={
					inputValue?.value === 'REQUESTED'
						? 'by-order border-0 bg-transparent'
						: 'by-tna-status border-0 bg-transparent'
				}
			>
				<option value={'Request Pending'} selected={inputValue?.value === 'Request Pending'}>
					Request Pending
				</option>
				<option value={'Request Completed'} selected={inputValue?.value === 'Request Completed'}>
					Request Completed
				</option>
				<option value={'Request Rejected'} selected={inputValue?.value === 'Request Rejected'}>
					Request Rejected
				</option>
			</select>
		</div>
	);
};

export default OrderCancelStatusFilter;
